<template>
  <div
    v-touch-pan.prevent.mouse="onDrag"
    class="resizer-standard"
    :class="[`edge-${edge}`, { 'is-dragging': isDragging }]"
    @dblclick="resetSize"
  >
    <div class="resizer-standard--hit-area" />
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineOptions({ name: 'Resizer' })
const model = defineModel({ type: Number, required: true })
const props = defineProps({
  edge: {
    type: String,
    required: true,
    validator: v => ['left', 'right', 'top', 'bottom'].includes(v)
  },
  limits: {
    type: Array,
    required: true,
    validator: v => v.length === 2
  }
})

const initialSize = model.value
const dragStartSize = ref(initialSize)
const isDragging = ref(false)

const resetSize = () => {
  model.value = initialSize
}

const onDrag = e => {
  isDragging.value = !e.isFinal
  if (e.isFirst) dragStartSize.value = model.value

  const isHorizontal = props.edge === 'left' || props.edge === 'right'
  const sign = props.edge === 'left' || props.edge === 'top' ? -1 : 1
  const size = dragStartSize.value + (isHorizontal ? e.offset.x : e.offset.y) * sign

  if (size > props.limits[0] && size < props.limits[1]) model.value = size
}
</script>

<style scoped>
@reference "#app-styles.css";

.resizer-standard {
  /* Positions relative to the nearest positioned ancestor - the consumer must give the resized container `position: relative` (or similar). */
  @apply absolute rounded-[1px] transition-colors duration-300 z-10;

  &:hover, &.is-dragging { @apply bg-primary-mid; }

  &.edge-left { @apply w-0.5 inset-y-0 left-0 -translate-x-1/2 cursor-col-resize; }
  &.edge-right { @apply w-0.5 inset-y-0 right-0 translate-x-1/2 cursor-col-resize; }
  &.edge-top { @apply h-0.5 inset-x-0 top-0 -translate-y-1/2 cursor-row-resize; }
  &.edge-bottom { @apply h-0.5 inset-x-0 bottom-0 translate-y-1/2 cursor-row-resize; }

  &.edge-left .resizer-standard--hit-area, &.edge-right .resizer-standard--hit-area {
    @apply inset-y-0 -inset-x-1.5;
  }
  &.edge-top .resizer-standard--hit-area, &.edge-bottom .resizer-standard--hit-area {
    @apply inset-x-0 -inset-y-1.5;
  }

  .resizer-standard--hit-area { @apply absolute; }
}
</style>
